import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function () {
    return createStyles({
        form_input: {
            display: 'none !important',
            width: '0 !important',
        },
        inputs: {
            display: 'flex',
        },
        input: {
            width: '48px',
            height: '48px',
            textAlign: 'center',
            borderRadius: '0.25rem',
            display: 'flex',
            justifyContent: 'center',
            padding: '0 0.6875rem',
            border: '1px solid var(--secundario-gris-azulado)',
            margin: '0 0.25rem',
            color: 'var(--gris-l43)',
            '&::placeholder': {
                width: '100%',
                borderBottom: '1px solid var(--secundario-gris-azulado)',
                margin: '0 auto',
                color: 'transparent',
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
            },
            '&:focus-visible': {
                border: '1px solid var(--primario-morado)',
                outline: '1px solid var(--primario-morado)',
            },
        },
        error: {
            display: 'flex',
            position: 'absolute',
            marginTop: '3.25rem',
            color: 'var(--error)',
        },
    });
});
export default useStyles;
